import { Env } from 'auth-common/shared';
import type { paths } from '../../generated/apiClient';
import { createQantApiClient } from '../../utils';

export const apiClient = createQantApiClient<paths>({ baseUrl: Env.Var.InterserviceApi.Domain });
